import {Component, Input, OnInit} from '@angular/core';
import {CommonComponent} from '../common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {IContactUs} from '../../../domain/IContactUs';
import {UnsecuredService} from '../../../services/unsecured.service';
import {NgForm} from '@angular/forms';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {CountryCode} from '../../../entity/CountryCodeEntity';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import { ReactiveService } from 'src/app/services/reactive.service';


@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent extends CommonComponent implements OnInit {
  @Input() textColor: string;
  contactData: IContactUs = {};
  formSubmitAttempt: boolean;
  countryCodes: CountryCode[] = [];
  phoneCountryCode: CountryCode = null;
  constructor(
    private unsecuredService: UnsecuredService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    protected router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
    private recaptchaV3Service: ReCaptchaV3Service,
    public reactiveService: ReactiveService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
        if (!this.phoneCountryCode) {
          this.phoneCountryCode = this.getDialCodePhoneData('1', this.configurationService.application);
          this.setCountryCode();
        } else{
          this.phoneCountryCode = this.getDialCodePhoneData(this.phoneCountryCode.dialCode, this.configurationService.application);
        }
      }
    );
  }

  ngOnInit(): void {
    if (!this.textColor) {
      this.textColor = '#ffffff';
    }
    this.formSubmitAttempt = false;

    this.reactiveService.isCompleted$.subscribe((value) => {
      if (value) {
        this.countryCodes = this.countryCodeCatalog(this.configurationService.application);
      }
    });

    this.phoneCountryCode = this.getDialCodePhoneData('1', this.configurationService.application);
    this.setCountryCode();
  }
  generateRecaptcha(form: NgForm){
    this.recaptchaV3Service.execute('send_otp').subscribe((token) => {
        this.contactData.reCaptchaToken = token;
        this.onSubmit(form);
      }, error => {
        this.msgError(error, this.translate.instant('shared.common.general_error_message'));
      }
    );
  }
  onSubmit(form: NgForm) {
    this.formSubmitAttempt = true;
    this.unsecuredService.sendContactUs(this.contactData).subscribe(
      (response: any) => {
        this.msgSuccess(this.translate.instant('shared.contact_us.message_success', {
          email: this.configurationService.home.contactEmail,
          Default: `Mensaje enviado correctamente. Te contactaremos desde la dirección ${this.configurationService.home.contactEmail}`
        }));
      }, error => {
        this.msgError(error);
      }
    );
    this.phoneCountryCode = this.getDialCodePhoneData('1', this.configurationService.application);
    this.setCountryCode();
    form.resetForm();
  }
  setCountryCode(){
    this.contactData.phoneCountryCode = this.phoneCountryCode.dialCode;
  }
}
